import React, { Component } from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import home from './container/home';
import about from './container/About';
import contact from './container/contact';
import Approuter from './Approuter'
import {auth, firebase} from './firebase'
import ModalConnection from './container/ModalConnectionSubscribe';
import Notification from 'rc-notification';
import 'rc-notification/assets/index.css';
// id dev
//const idRestaurant="-LHCvfvi5Zis0rJffGlg"
// id prod
const idRestaurant="-L8HPl47r9qChaUm_6uU"


let notification = null;
Notification.newInstance({}, (n) => notification = n);

class App extends Component {
  constructor(){
    super();
    this.state = {id : 1};
   
  }
  componentDidMount(){
   // alert(navigator.appCodeName)
    let messaging 
if(firebase.messaging.isSupported())
    {    messaging= firebase.messaging();
}    if(JSON.parse(localStorage.getItem('user'))){
        var iduser=JSON.parse(localStorage.getItem('user')).uid
        var ref_orders = firebase.database().ref(`/notification_tokens/${iduser}/`)
         var s=0
       /* var ref= firebase.database().ref(`/orders/${idRestaurant}`);
        ref.orderByChild('user_uid').equalTo(iduser).on('child_changed',(data)=>{
            var status=data.val().status
            console.log(data.val())
            console.log(data.key)
            console.log(s)
            if(s%2===0)
            if (status ==='canceled') {
                //title = 'Commande annulée';
                //body = 'Votre commande a été annulée.';
               
                notification.notice({
                    content: <span style={{fontSize:20}}><i style={{marginRight:20}} class="fa fa-bell "></i>Commande annulée</span>,
                    duration: null,
                    onClose() {
                      console.log('closable close');
                    },
                    closable: true,
                  });
                }
                else if (status ==='in_progress') {
                //title = 'Commande en cours de préparation';
                //body = 'Votre commande est en cours de préparation. Veuillez patienter.';
                //alert( 'Commande en cours de préparation')
                notification.notice({
                    content: <span style={{fontSize:20}}><i style={{marginRight:20}} class="fa fa-bell "></i>Commande en cours de préparation</span>,
                    duration: null,
                    onClose() {
                      console.log('closable close');
                    },
                    closable: true,
                  });
                }
                else if (status === 'validated') {
               // title = 'Commande terminée';
                //body = 'Votre commande est préparée.';
               // alert( 'Commande terminée')
               notification.notice({
                content: <span style={{fontSize:20}}><i style={{marginRight:20}} class="fa fa-bell "></i>Commande terminée</span>,
                duration: null,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
              });
                }
                s=s+1

        })
*/

if(firebase.messaging.isSupported()){

   messaging.onMessage(payload => {
      console.log("Notification Received", payload);
      notification.notice({
        content: <span style={{fontSize:20}}><i style={{marginRight:20}} class="fa fa-bell "></i>{payload.notification.body}</span>,
        duration: null,
        onClose() {
          console.log('closable close');
        },
        closable: true,
      });
     

   });

  
messaging.requestPermission().then(()=> {
        console.log('Notification permission granted.');
        messaging.getToken().then((currentToken)=> {
            console.log(currentToken)
          
            if (currentToken) 
            {
                ref_orders.set({web:currentToken})
             
             
            }
             else
            {
              // Show permission request.
              console.log('No Instance ID token available. Request permission to generate one.');
              // Show permission UI.
            
            }
            }).catch((err)=> {
            console.log('An error occurred while retrieving token. ',err);
       
          });
        // TODO(developer): Retrieve an Instance ID token for use with FCM.
        // ...

      }).catch((err)=> {
        console.log('Unable to get permission to notify.', err);
      });
    
    }
    }
  }

  render() {
      
    console.log(this.state)

    return (<div>
      <a id="toTopBtn" title="Go to top" href="javascript:void(0)">
            <i className="fa fa-chevron-up"></i>
        </a>
    
       
        <div className="loader">
            <h1>Loadings..</h1>
            <div id="cooking">
                <div className="bubble"></div>
                <div className="bubble"></div>
                <div className="bubble"></div>
                <div className="bubble"></div>
                <div className="bubble"></div>
                <div id="area">
                    <div id="sides">
                        <div id="pan"></div>
                        <div id="handle"></div>
                    </div>
                    <div id="pancake">
                        <div id="pastry"></div>
                    </div>
                </div>
            </div>
        </div>
<div  className="wrapper">



       <Approuter/>
      
    

       
    


   </div>
    

   </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js